import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormSeparator', null, { withChildren: true });
